<template>
  <t-form>
    <t-form-item label="音频" help="数据中指定了audioText时，优先读取audioText的文本，此配置不生效！">
      <t-select v-model="attribute.audioSrc" size="small">
        <t-option v-for="(item,index) in audioList" :key="index" :label="item.label" :value="item.value"/>
      </t-select>
    </t-form-item>
    <t-form-item label="循环播放">
      <t-switch v-model="attribute.loop" :label="['开', '关']" size="small"/>
    </t-form-item>
    <div style="width: 100%;text-align: center;border: 1px solid #252D41;padding: 10px 0"><!--告警配置、环形图/进度图-->
      <div style="text-align: center;margin-bottom: 10px;color: inherit;width: 100px;">自动播放:</div>
      <t-row>
        <t-col :span="2"></t-col>
        <t-col :span="5">条件</t-col>
        <t-col :span="5">目标值</t-col>
      </t-row>
      <t-row style="margin-top: 14px;">
        <t-col :span="2">数值</t-col>
        <t-col :span="5">
          <t-select v-model="attribute.alarmConfig.operator" size="small" style="width: 90px;">
            <t-option value=">" label=">"/>
            <t-option value="<" label="<"/>
            <t-option value="=" label="="/>
            <t-option value=">=" label=">="/>
            <t-option value="<=" label="<="/>
          </t-select>
        </t-col>
        <t-col :span="5">
          <t-input-number v-model="attribute.alarmConfig.threshold" theme="normal" size="small" style="margin-left: -15px;width: 90px;"/>
        </t-col>
      </t-row>
    </div>
  </t-form>
</template>

<script>
export default {
  name: "cpt-audio-option",
  props: { attribute: Object },
  data(){
    return {
      audioList: [
        {label:'瓶盖',value:'/audio/Bottle.ogg'},
        {label:'气泡',value:'/audio/Bubble.ogg'},
        {label:'牛蛙',value:'/audio/Bullfrog.ogg'},
        {label:'爆炸',value:'/audio/Burst.ogg'},
        {label:'叮当',value:'/audio/Clank.ogg'},
        {label:'音频6',value:'/audio/FadeIn.ogg'},
        {label:'音频7',value:'/audio/NotificationXylophone.ogg'},
        {label:'雷达',value:'/audio/Radar.ogg'},
        {label:'风铃',value:'/audio/WindChime.ogg'},
        {label:'提示',value:'/audio/temp.ogg'},
      ]
    }
  }
}
</script>

<style scoped>

</style>
